import React, { useState } from "react";
import "assets/scss/helpers/image.scss";

export default ({ src, alt, thumb }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleStateUpdate = (state) => {
    setIsLoaded(state);
  };

  return (
    <>
      <img
        className={"imageThumb"}
        alt={alt}
        src={thumb}
        style={{ visibility: isLoaded ? "visible" : "visible" }}
      />
      <img
        onLoad={() => {
          handleStateUpdate(true);
        }}
        className={"imageFull"}
        style={{ opacity: isLoaded ? 1 : 0 }}
        alt={alt}
        src={src}
      />
    </>
  );
};
